
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 import { SkySimpleTable as SkySimpleTableElement } from '@sky.ui/core/sky-simple-table';
 
 
 
 

 
 export const SkySimpleTable = createComponent({
   displayName: 'SkySimpleTable',
   react: React,
   tagName: 'sky-simple-table',
   elementClass: SkySimpleTableElement,
   events: {
     
   }
  });
export type * from '@sky.ui/core/sky-simple-table';
